/**------------------------------------------------------
 * Type Definitions
 */
export type TypeResolve<T = void> = (value: T | PromiseLike<T>) => void;
export type TypeReject     = (reason?: any) => void;
